import React, { type PropsWithChildren } from 'react';
import { Box, Flex, Heading, Text, useTheme } from '@chakra-ui/react';
import { useBreakpoint, useTranslate } from 'ts/common/hooks';

interface Props {
    contract: SpApi.Client.IContract;
    contractUserEmail: string | null;
}

const PageContainer: React.FC<PropsWithChildren<Props>> = ({
    children,
    contract,
    contractUserEmail
}) => {
    const isLargeScreen = useBreakpoint();
    const theme = useTheme();
    const t = useTranslate('contract.pageContainer');

    const contractUserFirstName = contract.contacts?.find(
        (contact) => contact.email === contractUserEmail
    )?.firstName;

    return (
        <Box
            alignSelf="flex-start"
            bg={{ base: 'paper', lg: 'paperBackground' }}
            color="var(--chakra-colors-text)"
            minHeight="100%"
            width="100%"
        >
            <Flex
                width="full"
                height={{ base: '50px', lg: '80px' }}
                backgroundColor="paper"
                alignItems="center"
            >
                <Heading as="h2" size="sm" color="brand.primary" margin={0} marginLeft="16px">
                    {contract.brandName}
                </Heading>
            </Flex>
            <Flex
                width="100%"
                backgroundColor="brand.primary"
                height={isLargeScreen ? '300px' : '200px'}
                marginX="auto"
                alignItems="center"
                justifyContent="center"
                overflow="hidden"
                flexDirection="column"
            >
                <Heading
                    as="h1"
                    letterSpacing={isLargeScreen ? '6px' : '3px'}
                    fontSize={isLargeScreen ? '3xl' : '2xl'}
                    color="white"
                    textTransform="uppercase"
                    margin={0}
                    size={isLargeScreen ? '3xl' : '2xl'}
                    textAlign="center"
                    textShadow="0px 5px 9px rgba(0, 0, 0, 0.25)"
                >
                    {contractUserFirstName ? `HI, ${contractUserFirstName}` : contract.name}
                </Heading>
                {contract.contacts?.[0]?.firstName && (
                    <Text textAlign="center" fontSize="lg" color="white" fontWeight="normal">
                        {t('pleaseReviewAndSignContract')}
                    </Text>
                )}
            </Flex>
            <Box
                background="paper"
                borderRadius="20px"
                boxSizing="border-box"
                fontFamily={theme.fonts}
                position="relative"
                boxShadow={isLargeScreen ? '0px 4px 40px 0px rgba(0, 0, 0, 0.08)' : undefined}
                margin={isLargeScreen ? '0 auto 40px' : undefined}
                maxWidth={isLargeScreen ? '960px' : undefined}
                padding={isLargeScreen ? '40px 34px' : '16px 16px 96px 16px'}
                top={isLargeScreen ? '-52px' : undefined}
            >
                {children}
            </Box>
        </Box>
    );
};

export default PageContainer;
